import { useRouterState } from "@tanstack/react-router";
import { useIsOnCall } from "~/hooks/useIsOnCall";

/**
 * アプリ内通知トーストを非表示にすべきパス（前方一致）。
 * - /profile/live-broadcaster: ライブ配信者プロフィール（配信待機）
 * - /purchase: PT購入画面
 * - /incoming: 着信画面
 * - /launch-campaign: 起動時キャンペーン動画
 */
const NOTIFICATION_HIDDEN_PATH_PREFIXES = [
  "/profile/live-broadcaster",
  "/purchase",
  "/incoming",
  "/launch-campaign",
];

/**
 * アプリ内通知トーストを非表示にすべきかどうかを返す。
 * 通話中・配信視聴中（{@link useIsOnCall}）に加え、
 * ライブ配信者プロフィール（配信待機）など特定ルートでも非表示にする。
 */
export const useIsInAppNotificationHidden = (): boolean => {
  const isOnCall = useIsOnCall();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const isOnHiddenPath = NOTIFICATION_HIDDEN_PATH_PREFIXES.some((prefix) =>
    pathname.startsWith(prefix),
  );

  return isOnCall || isOnHiddenPath;
};
